import { Search } from "lucide-react";
import { useEffect, useState } from "react";

const GlobalSearch = () => {
  const [gotAnInput, setGotAnInput] = useState(false);
  const [inputText, setInputText] = useState("");
  const [showText, setShowText] = useState(false);

  useEffect(() => {
    if (inputText.length <= 3) {
      if (inputText.length === 0) {
        setShowText(false);
      } else {
        const timer = setTimeout(() => {
          setShowText(true);
        }, 500);
        return () => clearTimeout(timer);
      }
      return;
    }

    setShowText(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gotAnInput]);

  return (
    <div className="w-96">
      <div className="flex gap-3 bg-white items-center rounded-2xl border border-solid px-3 py-2 shadow-sm text-[#888] text-sm">
        <Search />
        <input
          placeholder="Suchen..."
          className="border-none outline-none w-full"
          onChange={(e) => {
            setGotAnInput((prev) => !prev);
            setInputText(e.target.value);
          }}
          value={inputText}
        />
      </div>
      {showText && <p className="text-sm absolute text-red-500">Gib mindestens 4 Zeichen ein</p>}
    </div>
  );
};

export default GlobalSearch;
